export interface APIError {
  message: string;
  error: string;
  data?: unknown;
}

export class SwapKitAPIError extends Error {
  errorCode: string;
  data?: unknown;

  constructor(err: APIError) {
    super(err.message || err.error);
    this.name = "SwapKitAPIError";
    this.errorCode = err.error;
    this.data = err.data;
  }
}

export interface Fee {
  type: string;
  asset: string;
  networkFee: number;
  affiliateFee: number;
  totalFee: number;
  amount?: string;
}

export interface EstimatedTime {
  inbound: number;
  swap: number;
  outbound: number;
  total: number;
}

export interface Leg {
  chainId: string;
  hash?: string;
  block?: number;
  type: string;
  status: string;
  fromAsset: string;
  fromAmount: string;
  fromAddress?: string;
  toAsset: string;
  toAmount: string;
  toAddress?: string;
  meta?: unknown;
}

export interface AssetMeta {
  asset: string;
  price: number;
  image: string;
}

export interface RouteMeta {
  assets?: AssetMeta[];
  tags?: string[];
  txType?: string;
}

export interface NextAction {
  method: string;
  url: string;
  payload?: unknown;
}
